import React from "react";
import { withRouter } from "react-router-dom";
import withStyles from "react-jss";
import classNames from "classnames";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import v4 from "uuid";
import Metrika from "Services/Metrika";
import { AdverBlockContainer } from "Containers/AdBlocksContainer";
import OperatorItemContainer from "Containers/OperatorItemContainer";
import { EmptyStubWrapper } from "ComponentsUI/EmptyStub";
import { Col } from "ComponentsUI/Styles/Grid";

const styles = (theme) => ({
	root: {},
	wrapper: {
		display: "flex",
		justifyContent: "flex-start",
		alignItems: "flex-start",
		flexWrap: "wrap",
	},
	blocksWrapper: {
		marginBottom: "20px",
		width: "100%",
		borderRadius: "10px",
		"&:last-child": {
			marginBottom: 0,
		},
	},
	noFlatWrapper: {
		marginRight: "-10px",
		marginLeft: "-10px",
	},
	adblock: {
		width: "100%",
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		noFlatWrapper: {
			marginRight: "-5px",
			marginLeft: "-5px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		noFlatWrapper: {
			marginRight: "0",
			marginLeft: 0,
		},
		blocksWrapper: {
			marginBottom: "0",
		},
		adblock: {
			margin: "0 -20px",
			width: "auto",
		},
	},
});

class OperatorsList extends React.Component {
	static defaultProps = {
		onOperatorSelect: () => {},
		onOperatorConnect: () => {},
		onOperatorReviews: () => {},
		sendMetrica: () => {},
		withoutAdBlock: false,
	};

	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.sendYandexMetrika();
	}

	sendYandexMetrika() {
		try {
			Metrika.getInstance().yandex.sendEvent(this.props.yandexEvent, {
				params: { providers_count_view: this.props.items.length },
			});
		} catch (e) {
			console.warn("Error sendMetrica", e);
		}
	}

	generateOperators() {
		let items = this.props.items;
		let classes = this.props.classes;
		if (!this.props.windowSize.xs && !this.props.flat) {
			let blocks = [];
			let adElem = [
				<div className={classes.adblock} key={"adblock2"}>
					<AdverBlockContainer key="adblock2" />
				</div>,
			];
			items.map((item, index) => {
				if (!item?.sell_self?.provider?.name) {
					blocks.push(
						<OperatorItemContainer
							key={`${index}one`}
							text={this.props.text}
							onOperatorSelect={() => this.props.onOperatorSelect(item)}
							onOperatorConnect={() => this.props.onOperatorConnect(item)}
							onOperatorReviews={() => this.props.onOperatorReviews(item)}
							data={item}
							windowSize={this.props.windowSize}
							flat={this.props.flat}
							ratesView={this.props.ratesView}
						/>
					);
				} else {
					blocks.push(
						<OperatorItemContainer
							key={`${index}two`}
							selled={true}
							text={this.props.text}
							onOperatorSelect={() => this.props.onOperatorSelect(item)}
							onOperatorConnect={() => this.props.onOperatorConnect(item)}
							onOperatorReviews={() => this.props.onOperatorReviews(item)}
							data={item}
							windowSize={this.props.windowSize}
							flat={this.props.flat}
							ratesView={this.props.ratesView}
						/>
					);
				}
			});
			if (blocks.length > 8) {
				blocks.splice(8, 0, adElem);
			} else {
				blocks.push(adElem);
			}
			return blocks;
		} else {
			let blocks = [];
			let lastWasElite = false;
			let itemsInBlock = [];
			let blocksCounter = 0;
			let adBlockWasAdded = this.props.withoutAdBlock;
			let adBlockPlace = 8;
			for (var i = 0; i < items.length; i++) {
				let item = items[i];
				if (
					!!parseInt(item.vip_provider) === lastWasElite &&
					(adBlockWasAdded || i != adBlockPlace)
				) {
					if (!item?.sell_self?.provider?.name) {
						itemsInBlock.push(
							<OperatorItemContainer
								key={`${i}three`}
								text={this.props.text}
								onOperatorSelect={() => this.props.onOperatorSelect(item)}
								onOperatorConnect={() => this.props.onOperatorConnect(item)}
								onOperatorReviews={() => this.props.onOperatorReviews(item)}
								data={item}
								windowSize={this.props.windowSize}
								flat={this.props.flat && !this.props.windowSize.xs}
								ratesView={this.props.ratesView}
							/>
						);
					} else {
						itemsInBlock.push(
							<OperatorItemContainer
								key={`${i}four`}
								selled={true}
								text={this.props.text}
								onOperatorSelect={() => this.props.onOperatorSelect(item)}
								onOperatorConnect={() => this.props.onOperatorConnect(item)}
								data={item}
								windowSize={this.props.windowSize}
								flat={this.props.flat && !this.props.windowSize.xs}
								ratesView={this.props.ratesView}
							/>
						);
					}
				} else {
					if (itemsInBlock.length > 0) {
						blocks.push(
							<div key={blocksCounter} className={classes.blocksWrapper}>
								{itemsInBlock}
							</div>
						);
					}
					if (!adBlockWasAdded && i == adBlockPlace && !this.props.withoutAdBlock) {
						blocks.push(
							<div className={classes.adblock} key={"adblock2"}>
								<AdverBlockContainer key="adblock2" />
							</div>
						);
						adBlockWasAdded = true;
					}
					itemsInBlock = [];
					blocksCounter++;
					i--;
					lastWasElite = !lastWasElite;
				}
				if (i == items.length - 1) {
					if (itemsInBlock.length > 0) {
						blocks.push(
							<div key={blocksCounter} className={classes.blocksWrapper}>
								{itemsInBlock}
							</div>
						);
					}
				}
			}
			if (!adBlockWasAdded && !this.props.withoutAdBlock) {
				blocks.push(
					<div className={classes.adblock} key={"adblock2"}>
						<AdverBlockContainer key="adblock2" />
					</div>
				);
				adBlockWasAdded = true;
			}
			return blocks;
		}
	}

	render() {
		let { text } = this.props;
		let classes = this.props.classes;

		if (!this.props.items.length) {
			return (
				<EmptyStubWrapper
					headerText={text.NO_OPERATORS_HEADER}
					displayText={text.no_operator_info}
					buttonText={text.TO_MAIN_PAGE}
					iconHeader={"icon-balance"}
					iconButton={"icon-playlist-add"}
				/>
			);
		}
		return (
			<div className={classes.root}>
				<Container>
					<Row>
						<Col xs={12}>
							<div
								className={classNames(classes.wrapper, {
									[classes.noFlatWrapper]: !this.props.flat,
								})}
							>
								{this.generateOperators()}
							</div>
						</Col>
					</Row>
				</Container>
			</div>
		);
	}
}

export default withRouter(withStyles(styles)(OperatorsList));
